define(["require", "exports", "knockout", "../../utils/tools", "../../utils/kendoUtils", "../../models/UserContext", "../firewall/firewallActions"], function (require, exports, ko, tools, KendoUtils, UserContext, FirewallActions) {
    "use strict";
    var CustomerFirewallList = /** @class */ (function () {
        function CustomerFirewallList(customerId, lookupLists, defaultGroup, initGridCallback) {
            this.userCanViewFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.View,CustomerFirewall.Edit,CustomerFirewall.Delete"));
            this.userCanEditFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.Edit,CustomerFirewall.Delete"));
            this.userCanDeleteFirewall = ko.observable(UserContext.hasAccess("Admin,CustomerFirewall.Delete"));
            this.firewallActions = new FirewallActions();
            this.filterByAny = ko.observable("");
            var self = this;
            self.customerId = customerId;
            self.lookupLists = lookupLists;
            self.defaultFirewallGroup = defaultGroup;
            self.customerFirewallGridStructure = lookupLists.GridStructures.FirewallStructure;
            self.firewallActions.editFromCustomer(true);
            if (this.userCanViewFirewall()) {
                self.initExportDataSource();
                if (initGridCallback) {
                    initGridCallback(self);
                }
            }
        }
        CustomerFirewallList.prototype.initGrid = function () {
            var _this = this;
            if (this.userCanViewFirewall()) {
                this.initFirewall();
                ko.applyBindings(this, document.getElementById("divFirewallTable"));
                this.firewallActions.saveCallback = function () {
                    _this.customerFirewallTable.refresh();
                };
                this.firewallActions.deleteCallback = function () {
                    _this.customerFirewallTable.refresh();
                };
            }
        };
        CustomerFirewallList.prototype.initExportDataSource = function () {
            var _this = this;
            var self = this;
            self.customerFirewallDataSourceOptions = {
                transport: {
                    read: {
                        url: "/Firewall/GetIpAddressess",
                        type: "POST",
                        data: function () {
                            var data = {};
                            data.ipGroup = _this.defaultFirewallGroup;
                            data.customerIds = _this.customerId;
                            return data;
                        },
                        dataType: "json"
                    }
                },
                schema: {
                    model: self.customerFirewallGridStructure.model,
                    data: function (response) { return response.Data; },
                    total: "Total",
                    aggregates: "Aggregates",
                    errors: "Errors"
                },
                serverPaging: true,
                serverFiltering: true,
                serverSorting: true,
                serverAggregates: false
            };
            self.customerFirewallDataSource = new kendo.data.DataSource(self.customerFirewallDataSourceOptions);
        };
        CustomerFirewallList.prototype.initFirewall = function () {
            var _this = this;
            var self = this;
            var gridId = "divFirewallTable";
            var columns = self.customerFirewallGridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "140px",
                template: function (dataItem) {
                    var html = "";
                    if (self.userCanEditFirewall()) {
                        html += '<a class="btn btn-sm btn-warning btn-edit" href="#"><i class="fa fa-edit "></i></a>&nbsp;';
                    }
                    if (self.userCanDeleteFirewall()) {
                        html += '<button class="btn btn-sm btn-danger btn-remove" href="#"><i class="fa fa-trash-o "></i></button>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.customerFirewallTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Firewall/GetIpAddressess",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.ipGroup = self.defaultFirewallGroup;
                                data.customerIds = self.customerId;
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: self.customerFirewallGridStructure.model
                    }
                },
                gridOptions: {
                    toolbar: kendo.template($("#firewall-toolbar-template").html()),
                    columns: columns,
                    scrollable: true,
                    height: 500,
                },
                gridId: gridId,
                showPagerOnTop: false
            };
            self.customerFirewallTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.customerFirewallTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                _this.firewallActions.editIpAddress(data.Id, data.IpAddress);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(event.currentTarget);
                _this.firewallActions.deleteServerConfirm(data.Id, data.IpAddress);
                event.preventDefault();
            });
        };
        CustomerFirewallList.prototype.editFirewall = function () {
            var self = this;
            if (self.userCanEditFirewall()) {
                self.firewallActions.editIpAddress(null, null, self.customerId);
            }
            else {
                tools.error("Permission denied!");
            }
        };
        return CustomerFirewallList;
    }());
    return CustomerFirewallList;
});
//# sourceMappingURL=customerFirewallList.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/customers/customerFirewallList.js
// module id = 204
// module chunks = 2